export const currenciesListData = [
  {
    value: 'EUR',
    label: 'EUR',
  },
  {
    value: 'USD',
    label: 'USD',
  },
  {
    value: 'GBP',
    label: 'GBP',
  },
  {
    value: 'CHF',
    label: 'CHF',
  },
];
